import React, { EventHandler } from 'react';
import {
  RpCheck2Type,
  TestResultRp,
} from '@ecosconnect/core/src/types/jobFormData';
import AccordionItem from '../../../Accordion/AccordionItem';
import PropTypes from 'prop-types';
import { Input } from '../../../Form';
import ButtonToggle from '../../../Button/ButtonToggle';
import { yesNoOptions } from '../../options';
import {
  rpCheck2Required,
  rpOpenedAtRequired,
  rpPressureDropRequired,
} from '@ecosconnect/core/src/helpers/backflow/helpers';

type RpTestResultEditProps = {
  test: TestResultRp;
  rpCheck2Type: RpCheck2Type;
  onFormInputChange: EventHandler<any>;
};

const reliefValveDrippingOptions = [
  { label: 'No', value: 'no' },
  { label: 'Upon Arrival', value: 'upon_arrival' },
  { label: 'Upon #2 Closure', value: 'upon_closure' },
];

const check2Options = [
  { label: 'Tight', value: 'tight' },
  { label: 'Leaked', value: 'leaked' },
];

const didNotOpenOptions = yesNoOptions;

const RpTestResultEdit: React.FC<RpTestResultEditProps> = ({
  test,
  rpCheck2Type,
  onFormInputChange,
}) => {
  return (
    <>
      <AccordionItem
        flexDirection="column"
        label="Relief Valve Discharging"
        alignItems="flex-start"
        value={
          <ButtonToggle
            required
            name="reliefValveDripping"
            onClick={onFormInputChange}
            buttonOptions={reliefValveDrippingOptions}
            marginTop={1}
            value={test.reliefValveDripping}
          />
        }
      />

      <AccordionItem
        label="Relief Valve Did Not Open"
        alignItems="center"
        value={
          <ButtonToggle
            name="didNotOpen"
            onClick={onFormInputChange}
            buttonOptions={didNotOpenOptions}
            my={-1}
            value={typeof test.didNotOpen !== 'number' ? 0 : test.didNotOpen}
          />
        }
      />

      {!test.didNotOpen && (
        <AccordionItem
          label="Relief Valve Opened At"
          alignItems="center"
          as="label"
          value={
            <Input
              required={rpOpenedAtRequired(test)}
              onChange={onFormInputChange}
              variant="accordion"
              type="number"
              name="openedAt"
              value={test.openedAt}
              step="0.1"
              min="0"
              max="200"
              autoComplete="off"
            />
          }
        />
      )}

      <AccordionItem
        label="Check 1 Pressure Drop"
        alignItems="center"
        as="label"
        value={
          <Input
            required={rpPressureDropRequired(test)}
            onChange={onFormInputChange}
            variant="accordion"
            type="number"
            name="pressureDrop"
            value={test.pressureDrop}
            step="0.1"
            min="0"
            max="200"
            autoComplete="off"
          />
        }
      />
      {rpCheck2Type === 'USC10' && (
        <AccordionItem
          label="Check 2"
          alignItems="center"
          value={
            <ButtonToggle
              required={rpCheck2Required(test)}
              name="check2"
              onClick={onFormInputChange}
              buttonOptions={check2Options}
              my={-1}
              value={test.check2}
            />
          }
        />
      )}
      {test.check2 === 'other' && (
        <AccordionItem
          label="Check 2"
          alignItems="center"
          as="label"
          value={
            <Input
              required={rpCheck2Required(test)}
              onChange={onFormInputChange}
              variant="accordion"
              type="number"
              name="check2Other"
              value={test.check2Other}
              step="0.1"
              min="0"
              max="200"
              autoComplete="off"
            />
          }
        />
      )}
    </>
  );
};

RpTestResultEdit.propTypes = {
  test: PropTypes.any.isRequired,
};

export default RpTestResultEdit;
